import { Navigate } from "react-router-dom"
import { getLandingPage } from "src/services/whiteLabel"

const Home = () => <Navigate replace to={getLandingPage()} />

export default Home
